import { useEffect } from 'react';

/**
 * Tipografías de los presets de overlay (cowork y extensible). Se cargan solo en
 * las rutas de overlay para no agregar peso al sitio público; sin ellas todos
 * los presets se verían igual.
 */
const OVERLAY_FONTS_HREF = 'https://fonts.googleapis.com/css2'
  + '?family=Orbitron:wght@500;700;900'
  + '&family=Bebas+Neue'
  + '&family=Space+Grotesk:wght@400;500;700'
  + '&family=Poppins:wght@400;600;700'
  + '&family=Inter:wght@400;600;800'
  + '&family=Nunito:wght@400;600;800'
  + '&family=Quicksand:wght@400;500;700'
  + '&family=Playfair+Display:wght@400;600;700'
  + '&family=Caveat:wght@500;700'
  + '&family=JetBrains+Mono:wght@400;700'
  + '&display=swap';

export function useOverlayFonts() {
  useEffect(() => {
    if (document.querySelector('link[data-cowork-fonts]')) return;

    const preconnect = document.createElement('link');
    preconnect.rel = 'preconnect';
    preconnect.href = 'https://fonts.gstatic.com';
    preconnect.crossOrigin = 'anonymous';
    preconnect.setAttribute('data-cowork-fonts', 'preconnect');
    document.head.appendChild(preconnect);

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = OVERLAY_FONTS_HREF;
    link.setAttribute('data-cowork-fonts', 'css');
    document.head.appendChild(link);
  }, []);
}
